import { Button, ModalWindow, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './AuthMotivation.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AuthMotivation = function AuthMotivation(_ref) {
  var onClick = _ref.onClick,
    onClose = _ref.onClose,
    isAutorisationPopupOpened = _ref.isAutorisationPopupOpened;
  return /*#__PURE__*/_jsx(ModalWindow, {
    open: isAutorisationPopupOpened,
    width: 640,
    onClose: onClose,
    content: /*#__PURE__*/_jsxs("div", {
      "data-testid": "ChatAutorisationMotivationPopup",
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['img']
      }), /*#__PURE__*/_jsx(UIHeading3, {
        textAlign: "center",
        children: "\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E"
      })]
    }),
    footer: /*#__PURE__*/_jsx("div", {
      className: styles['footer'],
      children: /*#__PURE__*/_jsx(Button, {
        "data-testid": "ChatAutorisationMotivationPopupSignIn",
        onClick: onClick,
        children: "\u0412\u043E\u0439\u0442\u0438"
      })
    })
  });
};